// extracted by mini-css-extract-plugin
export var active = "_ap-d";
export var blink = "_ap-e";
export var container = "_ap-5";
export var controls = "_ap-0";
export var controlsRight = "_ap-1";
export var fakeCursor = "_ap-c";
export var hidden = "_ap-b";
export var quillContainerSmall = "_ap-7";
export var quillEditor = "_ap-6";
export var quillEditorSmall = "_ap-8";
export var quillFormatButtons = "_ap-a";
export var quillToolbar = "_ap-9";
export var removePadding = "_ap-2";
export var state = "_ap-3";
export var stateTitle = "_ap-4";